import React, { useState, useContext } from 'react';
import './styles.css';

import P from 'prop-types';
import { InputText } from '../InputText';
import { Button } from '../Button';
import API from '../../utils/api/office.instance';
import { toast } from 'react-toastify';
import { GlobalContext } from '../../contexts/HomeContext';
import { SaveUser } from '../../utils/utils';

export const ConfirmaSms = ({ modalParam }) => {
  const [codigo, setCodigo] = useState('');
  const { setUser } = useContext(GlobalContext);

  const handleCodigo = (event) => {
    let target = event.target;
    setCodigo(target.value);
  };

  const handleAutenticar = () => {
    if (isNaN(codigo)) {
      toast.warn('O código informado etá em um formato incorreto!', { containerId: 'modalToast' });
      return;
    }

    // caso seja pelo PreCadastro
    if (modalParam.onClick) {
      modalParam.onClick(codigo);
      return;
    }

    let obj = {
      codigo: codigo,
      cliente: modalParam.cliente,
    };

    // //Chamar api de Autenticação
    API.post('/office/AutoAtendimento/Autenticar', obj)
      .then((response) => {
        if (response.data == 0) {
          toast.error('Usuário não encontrado no cadastro!', { containerId: 'modalToast' });
        } else {
          modalParam.cliente.ativo = 1; // IMPORTANTE
          SaveUser(modalParam.cliente.idloja, modalParam.cliente, setUser);

          //encryptStorage.setItem(modalParam.idloja + 'user', JSON.stringify(modalParam));
          toast.success('Bem vindo ' + modalParam.cliente.nome + '!', { containerId: 'toastGeral' });
          if (modalParam.closeCadastro) setTimeout(() => modalParam.closeCadastro(), 600);
        }
      })
      .catch((err) => {
        toast.error('Erro interno do Servidor! ' + err, { containerId: 'modalToast' });
      });
    // //Gravar dados usuario na localstorage
  };
  //console.log(modalParam);
  return (
    <div className={'modal-content-dialog'}>
      <form>
        <div className={'form-group'} style={{ marginBottom: 20 }}>
          <p style={{ marginBottom: 20, textAlign: 'center' }}>Código enviado por SMS e por Email:</p>
          <p style={{ textAlign: 'center' }}>
            {/* Conclua seu cadastro inserindo o código enviado para:{' '} */}
            {'(' + modalParam.cliente.telefone_ddd + ') ' + modalParam.cliente.telefone}
          </p>
          <p style={{ marginBottom: 20, textAlign: 'center' }}>
            {/* Conclua seu cadastro inserindo o código enviado para:{' '} */}
            {modalParam.cliente.email}
          </p>

          <p style={{ textAlign: 'center', marginBottom: 10, fontWeight: 'bold' }}>Informe o Código</p>
          <InputText
            type={'text'}
            placeHolder={''}
            className="form-control input-full"
            textAlign="center"
            fontSize="24px"
            name={'codigo'}
            value={codigo}
            onChange={handleCodigo}
          />
        </div>
        <Button text="Autenticar" className="btnGradient btn-width-full" onClick={handleAutenticar} />
      </form>
      <div className={'clearfix-checkbox'}></div>
    </div>
  );
};

ConfirmaSms.propTypes = {
  modalParam: P.object,
};
